import { Token } from '@frontend/authentication-v2';
import { Spinner } from '@frontend/components/common';
import { Device } from '@frontend/device/types';

import { IoTTab } from '../app';
import Keyboard from '../emulators/keyboard/keyboard.component';
import QrReader from '../emulators/qr-reader/qr-reader.component';
import { EmulatorType } from '../emulators/types';
import ZhilaiDriver from '../emulators/zhilai-driver/zhilai-driver.component';
import useIotDashboard from './iot-dashboard.controller';

const ID = 'iot-dashboard';
export interface IotDashboardProps {
    iot: IoTTab;
}

const IotDashboard = (props: IotDashboardProps) => {
    const viewProps = useIotDashboard(props);

    return (
        <div id={ID}>
            {viewProps.devices && viewProps.token && viewProps.relevantDeviceInfo ? (
                viewProps.relevantDeviceInfo.length === 0 ? (
                    <p className='text-brand-muted text-sm'>No supported emulators found for this IoT device.</p>
                ) : (
                    <ul className='flex flex-col gap-4'>
                        {viewProps.relevantDeviceInfo.map((info) => (
                            <li key={info}>
                                <Emulator
                                    info={info}
                                    token={viewProps.token!}
                                    iot={props.iot}
                                    devices={viewProps.devices!}
                                />
                            </li>
                        ))}
                    </ul>
                )
            ) : (
                <div className='flex items-center justify-center p-8'>
                    <Spinner />
                </div>
            )}
        </div>
    );
};

export default IotDashboard;

const Emulator = ({ info, token, iot, devices }: { info: EmulatorType; token: Token; iot: IoTTab; devices: Device[] }) => {
    switch (info) {
        case EmulatorType.ZHILAI_DRIVER:
            return (
                <ZhilaiDriver
                    token={token}
                    iot={iot}
                    devices={devices}
                />
            );
        case EmulatorType.QR_READER:
            return (
                <QrReader
                    token={token}
                    iot={iot}
                    devices={devices}
                />
            );
        case EmulatorType.KEYBOARD:
            return (
                <Keyboard
                    token={token}
                    iot={iot}
                    devices={devices}
                />
            );
        default:
            return null;
    }
};
